import { errors as _errors } from 'lib_ui-primitives';

export default {
    verb: 'doingValidate',
    namespace: 'import',
    relation: 'import',
    description: 'Validate that Order # and SKU columns are mapped for order import',
    logic: validation
};

function validation({ data }) {
    const {
        newRecord: { columns, foreignNamespace, foreignRelation }
    } = data;

    if (foreignNamespace !== 'order' || foreignRelation !== 'order') return;

    const mappedPropertyNames = (columns || [])
        .filter(c => c?._meta?.id && c._meta.id !== '_skip')
        .map(c => c._meta.propertyName);

    const missing = [];
    if (!mappedPropertyNames.includes('title')) {
        missing.push('Order #');
    }
    if (!mappedPropertyNames.includes('sku')) {
        missing.push('SKU');
    }

    if (missing.length) {
        const message = `Required column(s) missing: ${missing.join(', ')}. Both Order # and SKU must be mapped.`;
        throw new _errors.ValidationError(message, {});
    }
}
